import React from "react";
import { connect } from "react-redux";
import UnshippedWorkWidget, {
  SALES_COLUMNS_WITH_SHIPMENT,
} from "./UnshippedWorkWidget";

// "Unshipped Jobs" — material still awaiting delivery, for warehouse staff.
//
// Orders are included only when they have an outstanding line whose BC item-card
// reservation policy is *not* "Never", i.e. genuine stockable goods. Labor-only
// orders are excluded: BC counts labor as shippable, so they would otherwise show
// here with nothing to load onto a truck. Its counterpart, Non Shipped Labor,
// reports the complement.
const UnshippedJobs = ({ auth: { auth } }) => (
  <UnshippedWorkWidget
    token={auth && auth[0] ? auth[0].token : null}
    endpoint="UnshippedJobs"
    title="Unshipped Jobs"
    icon="🚚"
    salesColumns={SALES_COLUMNS_WITH_SHIPMENT}
    salesSectionTitle="Sales Orders — Not Completely Shipped"
    showShipments
  />
);

const mapStateToProps = ({ auth }) => ({ auth });

export default connect(mapStateToProps)(UnshippedJobs);
